<template>
	<v-container>
		<v-card outlined>
			<v-card-title>
				Товары магазина
				<v-spacer></v-spacer>
				<import-seo-modal />
			</v-card-title>
			<v-card-text>
				<v-form ref="form" @submit.stop.prevent="submitFilters">
					<v-row>
						<v-col cols="12" sm="6" md="3">
							<v-select
								name="group"
								:items="selects.group.items"
								item-text="name"
								item-value="id"
								label="Группа товаров"
								outlined
								dense
								hide-details
							/>
						</v-col>

						<v-col cols="12" sm="6" md="3">
							<v-text-field
								name="url"
								label="Ссылка в магазине"
								outlined
								dense
								hide-details
							/>
						</v-col>

						<v-col cols="12">
							<v-btn
								type="submit"
								class="mr-2"
								outlined
							>
								Применить
							</v-btn>
							<v-btn
								color="grey"
								class="mr-2"
								outlined
								@click.stop="clearFilters"
							>
								Сбросить
							</v-btn>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-data-table
				:headers="headers"
				:items="products.data"
				:server-items-length="products.meta.total"
				:loading="loading"
				loading-text="Загрузка..."
				disable-sort
				@update:page="fetchProducts($event, products.meta.per_page, getFilters())"
				@update:items-per-page="fetchProducts(1, $event, getFilters())"
			>
				<template #item.name="{ item: product }">
					<v-tooltip top>
						<template #activator="{ on }">
							<a
								:href="$getShopUrl(`/catalog/products/${product.slug}`)"
								target="_blank"
								v-on="on"
							>
								{{ product.name }}
							</a>
						</template>
						<span>Открыть в магазине</span>
					</v-tooltip>
				</template>
				<template #item.h1="{ item: product }">
					<v-edit-dialog
						@open="dialogs.edit.value = product.h1"
						@save="updateProductH1(product, dialogs.edit.value)"
					>
						<template v-if="product.h1">
							<span>{{ product.h1 }}</span>
						</template>
						<template v-else>
							<span class="font-weight-thin">{{ product.name }}</span>
						</template>
						<template #input>
							<v-text-field
								v-model="dialogs.edit.value"
								label="H1"
								single-line
							/>
						</template>
					</v-edit-dialog>
				</template>
				<template #item.title="{ item: product }">
					<v-edit-dialog
						@open="dialogs.edit.value = product.title"
						@save="updateProductTitle(product, dialogs.edit.value)"
					>
						<template v-if="product.title">
							<span>{{ product.title }}</span>
						</template>
						<template v-else>
							<span class="font-weight-thin">{{ product.name }}</span>
						</template>
						<template #input>
							<v-text-field
								v-model="dialogs.edit.value"
								label="Title"
								single-line
							/>
						</template>
					</v-edit-dialog>
				</template>
				<template #item.description="{ item: product }">
					<v-edit-dialog
						@open="dialogs.edit.value = product.description"
						@save="updateProductDescription(product, dialogs.edit.value)"
					>
						<template v-if="product.description">
							<span>{{ product.description }}</span>
						</template>
						<template v-else>
							<span class="font-weight-thin">Пусто</span>
						</template>
						<template #input>
							<v-text-field
								v-model="dialogs.edit.value"
								label="Title"
								single-line
							/>
						</template>
					</v-edit-dialog>
				</template>
			</v-data-table>
		</v-card>
	</v-container>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import ImportSeoModal from '@/components/shop-products/import-seo-data-modal';

const DEFAULT_LIMIT = 10;

export default {
	name: 'ShopProductsIndexPage',
	components: { ImportSeoModal },
	data: () => ({
		loading: false,
		products: {
			data: [],
			meta: {
				total: 0,
				current_page: 1,
				per_page: 10,
			},
		},
		dialogs: {
			edit: {
				value: '',
			},
		},
		selects: {
			group: {
				items: [],
			},
		},
	}),
	computed: {
		headers() {
			return [
				{
					text: 'Группа',
					value: 'group.name',
				},
				{
					text: 'Наименование',
					value: 'name',
				},
				{
					text: 'H1',
					value: 'h1',
				},
				{
					text: 'Title',
					value: 'title',
				},
				{
					text: 'Description',
					value: 'description',
				},
			];
		},
	},
	async created() {
		await this.fetchGroups();
	},
	async mounted() {
		this.CancelToken = axios.CancelToken;
		this.sourceProducts = this.CancelToken.source();
		await this.fetchProducts(1, DEFAULT_LIMIT, this.getFilters());
	},
	methods: {
		async fetchProducts(page = 1, limit = null, filter = {}) {
			this.loading = true;
			limit = limit ? limit : this.products.meta.per_page;
			try {
				this.sourceProducts.cancel('Operation cancelled by user');
				this.sourceProducts = this.CancelToken.source();
				const response = await this.$http.get('/api/v1/shop-products', {
					params: {
						include: ['group', 'attributes'],
						page,
						limit,
						filter,
					},
					cancelToken: this.sourceProducts.token,
				});

				this.products = response.data;
				await this.setFiltersToURL(filter);
			} catch (e) {
				if (!axios.isCancel(e)) {
					this.$notify.error('Ошибка загрузки товаров');
				}
			} finally {
				this.loading = false;
			}
		},
		getFilters() {
			const initial = Object.fromEntries((new FormData(this.$refs.form.$el).entries()));
			return Object.keys(initial)
				.reduce((acc, key) => {
					if (!!initial[key]) {
						acc[key] = initial[key];
					}
					return acc;
				}, {});
		},
		submitFilters() {
			this.fetchProducts(1, DEFAULT_LIMIT, this.getFilters());
		},
		clearFilters() {
			this.$refs.form.reset();
			this.fetchProducts();
		},
		async setFiltersToURL(filters) {
			const query = qs.stringify(filters, {
				allowDots: true,
				skipNulls: true,
				encodeValuesOnly: true,
			});
			try {
				if (query.length) {
					await this.$router.push(`${this.$route.path}?${query}`)
				} else {
					await this.$router.push(this.$route.path);
				}
			} catch (e) {
			}
		},
		async fetchGroups() {
			try {
				const response = await this.$http.get('/api/v2/products/groups', {
					params: {
						filter: {
							shop: 1,
						},
					},
				});
				this.selects.group.items = response.data.data;
			} catch (e) {
			}
		},
		async updateProductH1(product, h1) {
			await this.updateProduct(product, {
				h1,
			});
		},
		async updateProductTitle(product, title) {
			await this.updateProduct(product, {
				title,
			});
		},
		async updateProductDescription(product, description) {
			await this.updateProduct(product, {
				description,
			});
		},
		async updateProduct(product, data) {
			if (this.loading) return;
			this.loading = true;
			try {
				const response = await this.$http.put(`/api/v1/shop-products/${product.slug}`, data);
				this.$notify('Товар изменен');
				product = response.data.data;
				this.products.data = this.products.data.map(p => p.slug === product.slug ? product : p);
			} catch (e) {
				this.$notify.error('Ошибка');
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style scoped>

</style>
